/*eslint-disable*/
import React from "react";
import { Helmet } from "react-helmet-async";
import classNames from "classnames";
import { makeStyles } from "@material-ui/core/styles";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Parallax from "components/Parallax/Parallax.js";
import SectionDescription from "views/AboutUsPage/Sections/SectionDescription.js";
import SectionTeam from "views/AboutUsPage/Sections/SectionTeam.js";
import SectionServices from "views/AboutUsPage/Sections/SectionServices.js";
import SectionOffice from "views/AboutUsPage/Sections/SectionOffice.js";
import MyHeader from "views/MyBangles/Section/MyHeader";
import MyHeaderLinks from "views/MyBangles/Section/MyHeaderLinks";
import MyFooter from "views/MyBangles/Section/MyFooter";
import aboutUsStyle from "assets/jss/material-kit-pro-react/views/aboutUsStyle.js";
import aboutUsStyl from "assets/jss/material-kit-pro-react/views/blogPostsPageStyle.js";

const responsiveStyle = {
  responsiveParallax: {
    minHeight: "420px",
    height: "auto",
    backgroundSize: "cover !important",
    backgroundPosition: "center center !important",
    backgroundRepeat: "no-repeat !important",
    display: "flex",
    alignItems: "center",

    "@media (max-width: 991px)": {
      minHeight: "380px",
      backgroundPosition: "center center !important",
    },

    "@media (max-width: 767px)": {
      minHeight: "360px",
      paddingTop: "90px",
      paddingBottom: "40px",
      backgroundSize: "cover !important",
      backgroundPosition: "center top !important",
    },

    "@media (max-width: 480px)": {
      minHeight: "340px",
      paddingTop: "85px",
      paddingBottom: "35px",
      backgroundPosition: "center top !important",
    },
  },

  heroTitle: {
    color: "#fff",
    fontSize: "48px",
    lineHeight: "1.2",
    marginBottom: "15px",

    "@media (max-width: 767px)": {
      fontSize: "34px",
    },

    "@media (max-width: 480px)": {
      fontSize: "30px",
    },
  },

  heroText: {
    color: "#fff",
    fontSize: "16px",
    lineHeight: "1.7",
    maxWidth: "850px",
    margin: "0 auto",

    "@media (max-width: 767px)": {
      fontSize: "14px",
      lineHeight: "1.6",
      padding: "0 15px",
    },
  },
};

const useStyles = makeStyles(aboutUsStyle);
const useStyle = makeStyles(aboutUsStyl);
const useResponsiveStyle = makeStyles(responsiveStyle);

export default function AboutUsPage() {
  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  });
  const classes = useStyles();
  const classe = useStyle();
  const responsiveClasses = useResponsiveStyle();

  const currentUrl = "https://mybangles24.com/about-us";
  const seoTitle =
    "About Us | MY BANGLES 24 - Imitation Jewellery Manufacturer in India";
  const seoDescription =
    "Learn about MY BANGLES 24, a trusted imitation jewellery manufacturer and exporter in India, known for quality, design, value, and customer satisfaction.";
  const seoKeywords =
    "About MY BANGLES 24, imitation jewellery manufacturer, bangles manufacturer in India, jewellery exporter, wholesale bangles, artificial jewellery supplier";
  const ogImage =
    "https://inshabangles.com/imgstore/original_logo/IndianBanglesImgLogo.png";

  const aboutPageSchema = {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    name: "About Us - MY BANGLES 24",
    url: currentUrl,
    description: seoDescription,
    mainEntity: {
      "@type": "Organization",
      name: "MY BANGLES 24",
      url: "https://mybangles24.com",
      logo: ogImage,
    },
  };

  return (
    <div>
      <Helmet>
        {/* <title>About Us</title> */}
        <html lang="en" />
        <title>{seoTitle}</title>
        <meta name="description" content={seoDescription} />
        <meta name="keywords" content={seoKeywords} />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={currentUrl} />

        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="MY BANGLES 24" />
        <meta property="og:title" content={seoTitle} />
        <meta property="og:description" content={seoDescription} />
        <meta property="og:url" content={currentUrl} />
        <meta property="og:image" content={ogImage} />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={seoTitle} />
        <meta name="twitter:description" content={seoDescription} />
        <meta name="twitter:image" content={ogImage} />

        <script type="application/ld+json">
          {JSON.stringify(aboutPageSchema)}
        </script>
      </Helmet>
      <MyHeader
        color="transparent"
        brand="Home"
        links={<MyHeaderLinks dropdownHoverColor="primary" />}
        fixed
        changeColorOnScroll={{
          height: 300,
          color: "primary",
        }}
      />
      <Parallax
        image={require("assets/img/About-Us.jpg").default}
        filter="dark"
        small
        // className={responsiveClasses.responsiveParallax}
      >
        <div className={classe.container}>
          <GridContainer justify="center">
            <GridItem
              md={8}
              sm={8}
              className={classNames(
                classe.mlAuto,
                classe.mrAuto,
                classe.textCenter,
              )}
            >
              <h1 className={classe.title}>About Us</h1>
              <h6 style={{ color: "white" }}>
                Our aim is to give every customer much more than what he/she
                asks for in terms of quality, selection, value for money and
                customer service, by understanding local tastes and preferences
                and innovating constantly to eventually provide an unmatched
                experience in Bangles shopping.
              </h6>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>
      <div className={classNames(classes.main, classes.mainRaised)}>
        <div className={classes.container}>
          <SectionDescription />
          <SectionTeam />
          <SectionServices />
          <SectionOffice />
        </div>
      </div>
      <MyFooter />
    </div>
  );
}
